import { TypedUseSelectorHook, useSelector } from 'react-redux'
import type { RootState } from '../stores'

/**
 * Typed version of the `useSelector` hook from React-Redux
 * This allows for type-safe access to the Redux store state
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
